const LOCAL_STORAGE_KEY = {
    TOKEN: 'autentika_app_token',
    ADMIN_ROLE: 'admin_role_access'
}


export default LOCAL_STORAGE_KEY;